import { axiosDevelopment } from "./config";

export const FlimpIconsService = {
  GET_FLIMP_ICONS() {
    return axiosDevelopment.get('get-flimp-icons');
  },
};
